import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('hero-slider', {
  onLoad() {
    this.settings = this.container.dataset.sectionSettings || '{}';

    this.sliderId = `#hero-slider--${this.id}`;
    const thisSlider = document.querySelector(`#hero-slider--${this.id}`);

    // Parse the settings string passed through from liquid
    this.userSettings = JSON.parse(this.settings);

    this.previousButton = document.querySelector('.btn--control-prev');
    this.nextButton = document.querySelector('.btn--control-next');

    const slider = new Flickity(thisSlider, {
      prevNextButtons: false,
      autoPlay: this.userSettings && this.userSettings.autoplay ? 8000 : false,
      pageDots: this.userSettings.include_pager_dots,
      adaptiveHeight: true,
      watchCSS: true,
      wrapAround: this.userSettings.infinite,
      on: {
        ready() {
          thisSlider.classList.add('is-visible');
        },
      },
    });

    this?.previousButton?.addEventListener('click', () => slider.previous());
    this?.nextButton?.addEventListener('click', () => slider.next());
  },
});
